// Protected Higher Level Pages
import { ProtectedPage } from 'src/layout/ProtectedPage/ProtectedPage';
import { SidebarProjectLayoutV2 } from 'src/layout/SidebarLayout/SidebarProjectLayout/v2/SidebarProjectLayoutV2';

import { ProjectProtectedPage } from '../ProjectProtectedPage/ProjectProtectedPage';

export const ProtectedPageWithProjectSidebar = (
  <ProtectedPage>
    <ProjectProtectedPage>
      <SidebarProjectLayoutV2 />
    </ProjectProtectedPage>
  </ProtectedPage>
);
